import React from 'react';
import { itemTitle, itemVariant, itemPrice, itemQuantity } from '../utils/orderPresentation';
import ProductIdentity from './ProductIdentity';

export default function OrderProductList({ items = [], limit, prices = true }) {
  return <div className="order-product-list">
    {items.slice(0, limit ?? items.length).map((item, index) => <div className="order-product-line" key={item.id || `${itemTitle(item)}-${index}`}>
      <ProductIdentity product={item} title={itemTitle(item)}><small>{itemVariant(item) ? `Размер: ${itemVariant(item)} · ` : ''}{itemQuantity(item)} шт.</small></ProductIdentity>
      {prices && <strong className="order-product-price">{(itemPrice(item) * itemQuantity(item)).toLocaleString('ru-RU')} ₽</strong>}
    </div>)}
    {limit && items.length > limit && <p className="order-product-more">Ещё {items.length - limit} в составе заказа</p>}
  </div>;
}
